/**
 * Use this function to refresh the Klarna OSM placements. Especially useful if we have configurable products where
 * pricing may change.
 *
 * The refresh function is supplied from the Klarna Library which we load in on the page using a script tag.
 *
 * To use this, we have to determine whether we are in browser or not, so we add an isServer check before running the
 * function from the window.
 *
 * @see https://docs.klarna.com/on-site-messaging/in-depth-knowledge/placements/#refresh-placements
 */
export const RefreshKlarnaOSMPlacements = () => {
    const isServer = typeof window === 'undefined';
    return !isServer && (window as any)?.Klarna?.OnsiteMessaging?.refresh();
};
